"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _react = require("@emotion/react");
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "1gk7m0n",
  styles: "&>li{height:50px;&>a,&>button{position:relative;display:flex;justify-content:flex-start;align-items:center;width:100%;padding:0;text-decoration:none;&:hover,&:focus{& svg{right:-5px;}}&:focus-visible{text-decoration:underline;}&>span{padding:0.5em 20px 0.5em 0;font-size:16px;font-weight:600;text-align:left;& svg{position:absolute;right:0;top:6px;}}}}"
} : {
  name: "fygu67-linksAlternate",
  styles: "&>li{height:50px;&>a,&>button{position:relative;display:flex;justify-content:flex-start;align-items:center;width:100%;padding:0;text-decoration:none;&:hover,&:focus{& svg{right:-5px;}}&:focus-visible{text-decoration:underline;}&>span{padding:0.5em 20px 0.5em 0;font-size:16px;font-weight:600;text-align:left;& svg{position:absolute;right:0;top:6px;}}}};label:linksAlternate;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "1k3z293",
  styles: "&>li{height:unset;border-top:none;&>a,&>button{position:relative;display:flex;justify-content:flex-start;width:100%;padding:0;text-decoration:none;&:focus-visible{text-decoration:underline;}&:hover,&:focus{& svg{right:-5px;}}&>span{padding:0.5em 0;font-size:15px;line-height:19px;border-bottom:1px solid #1657e2;& svg{position:absolute;right:0;top:6px;}}}}"
} : {
  name: "u7s89b-links",
  styles: "&>li{height:unset;border-top:none;&>a,&>button{position:relative;display:flex;justify-content:flex-start;width:100%;padding:0;text-decoration:none;&:focus-visible{text-decoration:underline;}&:hover,&:focus{& svg{right:-5px;}}&>span{padding:0.5em 0;font-size:15px;line-height:19px;border-bottom:1px solid #1657e2;& svg{position:absolute;right:0;top:6px;}}}};label:links;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: theme => /*#__PURE__*/(0, _react.css)({
    padding: 0,
    margin: 0,
    listStyle: 'none',
    '& > li': {
      display: 'flex',
      alignItems: 'center',
      height: '36px',
      fontSize: '16px',
      borderTop: '1px solid ' + theme.border,
      '&:nth-of-type(1)': {
        borderTop: 'none'
      }
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:default;"),
  points: theme => /*#__PURE__*/(0, _react.css)({
    '& > li': {
      display: 'flex',
      alignItems: 'center',
      height: '30px',
      borderTop: 'none',
      paddingLeft: '30px'
    },
    '& > li::before': {
      content: '""',
      height: '8px',
      width: '8px',
      borderRadius: '50%',
      backgroundColor: theme.primary,
      marginLeft: '-20px',
      marginRight: '10px;'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:points;"),
  links: theme => _ref2,
  linksAlternate: theme => _ref,
  ordered: {},
  numbers: {
    listStyle: 'none',
    counterReset: 'conts',
    '& > li': {
      height: '30px',
      borderTop: 'none',
      paddingLeft: '30px',
      counterIncrement: 'conts'
    },
    '& > li::before': {
      content: 'counter(conts)"."',
      fontSize: '16px',
      fontWeight: 'normal',
      marginLeft: '-20px',
      marginRight: '10px;'
    }
  },
  numbersHighlighted: theme => /*#__PURE__*/(0, _react.css)({
    listStyle: 'none',
    counterReset: 'conts',
    '& > li': {
      height: '40px',
      borderTop: 'none',
      paddingLeft: '30px',
      counterIncrement: 'conts',
      fontWeight: 600
    },
    '& > li::before': {
      content: 'counter(conts)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.primary,
      borderRadius: '50%',
      height: '24px',
      width: '24px',
      color: 'white',
      fontSize: '16px',
      fontWeight: 600,
      marginLeft: '-20px',
      marginRight: '10px'
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:numbersHighlighted;"),
  selectList: theme => /*#__PURE__*/(0, _react.css)({
    cursor: 'pointer',
    borderTop: '1px solid ' + theme.border,
    listStyle: 'none',
    '& > li': {
      paddingLeft: '5px',
      display: 'flex',
      alignItems: 'center',
      height: '36px',
      fontSize: '16px',
      background: 'white',
      '&:nth-of-type(1)': {
        borderTop: 'none'
      },
      '&:hover': {
        backgroundColor: theme.bgLight,
        borderColor: theme.bgLight,
        color: theme.btnHoverTextColor + '!important'
      }
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:selectList;"),
  nostyle: process.env.NODE_ENV === "production" ? {
    name: "47nd67",
    styles: "&>li{height:30px;border-top:none;border-bottom:0;}"
  } : {
    name: "zcsux3-nostyle",
    styles: "&>li{height:30px;border-top:none;border-bottom:0;};label:nostyle;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  rowHeight: height => /*#__PURE__*/(0, _react.css)("&>li{height:", height, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:rowHeight;")),
  minRowHeight: height => /*#__PURE__*/(0, _react.css)("&>li{min-height:", height, ";height:unset;}" + (process.env.NODE_ENV === "production" ? "" : ";label:minRowHeight;")),
  darkTheme: theme => /*#__PURE__*/(0, _react.css)("border-top:none;li,li:hover,li:active{background-color:", theme.submenuItemColor, ";border-color:", theme.btnBackBorder, ";&>button{color:", theme.submenuTextColorActive, ";&:focus{color:", theme.submenuTextColorActive, ";}}}" + (process.env.NODE_ENV === "production" ? "" : ";label:darkTheme;")),
  setPadding: padding => /*#__PURE__*/(0, _react.css)("&>li{padding:", padding, " 0;}&>li:first-of-type{padding:0 0 ", padding, " 0;}&>li:last-of-type{padding:", padding, " 0 0 0;}&>li:only-of-type{padding:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:setPadding;"))
};
var _default = exports.default = styles;